import React from "react";
import { Routes, Route } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Landing from "./pages/Landing";
import Login from "./pages/auth/Login";
import ForgotPassword from "./pages/auth/ForgotPassword";
import VerifyOTP from "./pages/auth/VerifyOTP";
import Dashboard from "./pages/promoters/Dashboard";
import DealDetails from "./pages/DealDetails";
import TrendingDeals from "./pages/TrendingDeals";
import Earnings from "./pages/Earnings";
import Profile from "./pages/Profile";
import MyAffiliateLinks from "./pages/MyAffiliateLinks";
import PayoutSetup from "./pages/PayoutSetup";
import AppliedDeals from "./pages/AppliedDeals";
import Register from "./pages/auth/Register";
import AccountVerification from "./pages/auth/AccountVerification";
import ContactUs from "./pages/ContactUs";
import ProtectedRoute from "./components/ProtectedRoute";
import AuthOnlyRoute from "./components/AuthOnlyRoute";
import RootRedirect from "./components/RootRedirect";
import VerificationChecker from "./components/VerificationChecker";

function AppRoutes() {
  return (
    <Routes>
      {/* Root Route - Smart redirect based on auth status */}
      <Route path="/" element={<RootRedirect />} />
      <Route path="/landing" element={<Landing />} />
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/verify-otp" element={<VerifyOTP />} />
      <Route path="/contact-us" element={<ContactUs />} />
      <Route
        path="/deal/:dealSlug"
        element={<DealDetails isAuthenticated={false} />}
      />
      <Route
        path="/trending"
        element={<TrendingDeals isAuthenticated={false} />}
      />

      {/* Auth Only Routes (Authentication required, verification not required) */}
      <Route
        path="/verify-email"
        element={
          <AuthOnlyRoute>
            <AccountVerification />
          </AuthOnlyRoute>
        }
      />

      {/* Protected Routes (Authentication + Verification required) */}
      <Route
        path="/dashboard"
        element={
          <ProtectedRoute>
            <Dashboard />
          </ProtectedRoute>
        }
      />
     
      <Route
        path="/earnings"
        element={
          <ProtectedRoute>
            <Earnings />
          </ProtectedRoute>
        }
      />
      <Route
        path="/profile"
        element={
          <ProtectedRoute>
            <Profile />
          </ProtectedRoute>
        }
      />
      <Route
        path="/my-affiliate-links"
        element={
          <ProtectedRoute>
            <MyAffiliateLinks />
          </ProtectedRoute>
        }
      />
      <Route
        path="/payout-setup"
        element={
          <ProtectedRoute>
            <PayoutSetup />
          </ProtectedRoute>
        }
      />
      <Route
        path="/applied-deals"
        element={
          <ProtectedRoute>
            <AppliedDeals />
          </ProtectedRoute>
        }
      />
      <Route
        path="/trending-authenticated"
        element={
          <ProtectedRoute>
            <TrendingDeals isAuthenticated={true} />
          </ProtectedRoute>
        }
      />
      <Route
        path="/deal-authenticated/:dealSlug"
        element={
          <ProtectedRoute>
            <DealDetails isAuthenticated={true} />
          </ProtectedRoute>
        }
      />

    </Routes>
  );
}

function App() {
  return (
    <VerificationChecker>
      <AppRoutes />
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
        toastId="main-toast"
        enableMultiContainer={false}
      />
    </VerificationChecker>
  );
}

export default App;
